import PageStyle from "@/styles/components/share-cv/_index.module.scss";
import { Field, FieldArray, Form, FormStyle, Formik, FormikControl, InputError } from '@/imports-files/common/common';
import { Button, ComponentStyle} from '@/imports-files/components/confirmation-modal';
import {Yup, TRANSLATION, todayDate, tomorrowDate} from '@/imports-files/pages/interviews/cronofy';
import { InfoModalStyle, Close } from "@/imports-files/components/common-modal/common-modal";

export function CancelReasonPopup({setBtnPopup, meetingDetails}) {
  return (
    <div className={`${InfoModalStyle.ModalOverlay}`}>
      <div className={`${InfoModalStyle.Modal} ${PageStyle.CancelReason__inner} mw-90-xs`}>
        <div className={`${InfoModalStyle.Modal__Container}`}>
          <div
            className={`${InfoModalStyle.Modal__Container__CloseSection}`}
            onClick={()=> setBtnPopup(false)}
          >
            <Close/>
            CLOSE
          </div>

        <div className={`CancelInterview ${InfoModalStyle.Modal__Container__ContentSection} ${PageStyle.CancelReason__Content} DisplayInline`}>
            <h3 className={`${InfoModalStyle.Modal__Container__ContentSection__Heading} mt20`}>Cancelled Interview</h3>
            <div className={`${InfoModalStyle.Modal__Container__ContentSection__SubHeading} ${PageStyle.CancelReason__ContentBlock} mt30`}>
              <label>Reason for cancellation</label>
            </div>
            <div className={`${PageStyle.SetupPopup__ContentBlock} ${PageStyle.CancelReason__ContentBlock}`}>
              <p className={`${InfoModalStyle.Modal__Container__ContentSection__Point}`}>{meetingDetails.details?.reason}</p>
            </div> 
           </div>
        </div>
      </div>
    </div>
  )

}
